/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { FormsUpdatePathParams, FormsUpdateRequest, FormsUpdateResponse } from '../types/FormsUpdate'

/**
 * PUT /forms/:form
 * @see backend/nexus/modules/Form/Http/Controllers/FormController.php FormController::update
 */
export async function formsUpdate(
	form: FormsUpdatePathParams['form'],
	data: FormsUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<FormsUpdateResponse>> {
	return axiosInstance.put(`/forms/${form}`, data, config)
}
